import { isEmpty } from 'lodash'

import { hasAnySim, isAllFilled, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta01ExemplosEnum,
  ConsultaSeguimentoPergunta01Model,
} from './model-consultaSeguimentoPergunta01'

const pergunta01ExemplosEnumValues = Object.values(ConsultaSeguimentoPergunta01ExemplosEnum)

export function isPergunta01ExemplosAllFilled(
  value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']
): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllFilled(allExemplos, pergunta01ExemplosEnumValues)
}

export function isPergunta01ExemplosAllNao(value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']): boolean {
  const allExemplos = { ...value?.PASSOU, ...value?.FALHOU }
  return isAllNao(allExemplos, pergunta01ExemplosEnumValues)
}

export function hasPergunta01ExemplosPassouAnySim(
  value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']
): boolean {
  const exemplosPassou = value?.PASSOU ?? {}
  return !isEmpty(exemplosPassou) && hasAnySim(exemplosPassou)
}

export function hasPergunta01ExemplosFalhouAnySim(
  value: ConsultaSeguimentoPergunta01Model['PERGUNTA_01_EXEMPLOS']
): boolean {
  const exemplosFalhou = value?.FALHOU ?? {}
  return !isEmpty(exemplosFalhou) && hasAnySim(exemplosFalhou)
}

export function prunePergunta01(value: ConsultaSeguimentoPergunta01Model): ConsultaSeguimentoPergunta01Model {
  const pruned: ConsultaSeguimentoPergunta01Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_01_HEADER: value.PERGUNTA_01_HEADER,
    PERGUNTA_01_EXEMPLOS: value.PERGUNTA_01_EXEMPLOS,
  }

  const hasPerguntaExemplosPassouAnySim = hasPergunta01ExemplosPassouAnySim(value.PERGUNTA_01_EXEMPLOS)
  const hasPerguntaExemplosFalhouAnySim = hasPergunta01ExemplosFalhouAnySim(value.PERGUNTA_01_EXEMPLOS)

  if (hasPerguntaExemplosPassouAnySim && hasPerguntaExemplosFalhouAnySim) {
    pruned.PERGUNTA_01_MAIOR_FREQUENCIA = value.PERGUNTA_01_MAIOR_FREQUENCIA
  }

  return pruned
}
